// @flow

// Libs
import _size from 'lodash/size'

// Effect Managers
import { take, put, select, call } from 'redux-saga/effects'

// Constants
import {
  CITY_SEARCH_URL,
  CITY_SEARCH_QUERY_REST,
} from 'fc-map-search/src/constants'

// Types
import type { BillingInfo } from 'hfty-model-billing-info'

// Selectors
import userBillingInfo$ from 'hfty-users/src/selectors/userBillingInfo'

// Action creators
import { setUserStateBbox } from '../actions'

// Constants
import { CENTER_MAP_DEFAULT } from '../constants'

// Controllers
import userCtrl from 'fc-ctrl-users'

export default function *watchCenterMapDefault (): Generator<*, *, *> {
  while (true) {
    yield take(CENTER_MAP_DEFAULT)
    yield call(centerMapToDefaultLocation)
  }
}

export function *centerMapToDefaultLocation (): Generator<*, *, *> {
  const map = window._m
  // Look up user's location for Map initialization
  let address = yield select(userBillingInfo$)

  while (!address) {
    yield take(userCtrl.actionTypes.receive())
    address = yield select(userBillingInfo$)
  }

  const response = yield fetchLocationBbox(address)

  if (response && _size(response) && !response.error) {
    const [minY, maxY, minX, maxX] = response[0].boundingbox
    const locationBbox = [[+minY, +minX], [+maxY, +maxX]]

    yield put(setUserStateBbox(locationBbox))
    map.fitBounds(locationBbox)
  }
}

export function fetchLocationBbox (address: BillingInfo): Object {
  const url: string = `${CITY_SEARCH_URL}${address.city},${address.province}${CITY_SEARCH_QUERY_REST}`
  return fetch(url)
    .then((response: Object): Object => {
      if (response.statusText === 'OK') {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    })
    .then((response: Object): Object => response.json())
    .catch((error: Object): Object => {
      return {error}
    })
    .then((data: Object): Object => {
      return data
    })
}
